/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { groupAlternativesByTitle } from '../utils/groupAlternativesByTitle';

export default function MainQuestionIsNotGradeTable({
  dataToShow,
  headerHeight,
  mainAlternatives,
}) {

  // Renderiza as linhas da grade
  const renderGridRows = (alternativas) => {
    if(!alternativas) return null;

    return (
      alternativas.map((alternativa) => (
        <tr key={alternativa.id}>
          <td className="row">{alternativa.titulo_grade}</td>
          <td className={'respondentes resultadoNumerico'}>
            <span>{alternativa.resultado_numerico}</span>
          </td>
          <td className="respondentes resultadoPercentual">
            {`${alternativa.resultado_percentual}%`}
          </td>
          {alternativa.cruzamentos
            && mainAlternatives.map((item) => (
              <td
                className={`resultado-cruzamento ${alternativa.cruzamentos[item.id].marcacao && alternativa.cruzamentos[item.id].marcacao.is_checked ? 'selecionado' : ''}`}
                key={item.id}
                title={`Equivale a ${alternativa.cruzamentos[item.id] ? alternativa.cruzamentos[item.id].resultado_numerico : ''} resposta(s)`}
              >
                <span>{`${alternativa.cruzamentos[item.id] ? alternativa.cruzamentos[item.id].resultado_percentual : 0}%`}</span>
              </td>
            ))}
        </tr>
      ))
    )
  }

  // Agrupa as alternaatives pela coluna da grade
  const groupAlternativesByGridColumn = (pergunta) => {
    if(!pergunta) return null;

    return (
      Object.entries(groupAlternativesByTitle(pergunta.alternativas)).map(([enunciado, alternativas]) => (
        <React.Fragment key={enunciado}>
          <tr>
            <td className="gradeTitle">{enunciado}</td>
            <td colSpan={dataToShow.perguntas_principais[0].alternativas.length + 3} className="gradeTitle-col"></td>
          </tr>

          {/* linhas da grade */}
          {renderGridRows(alternativas)}
        </React.Fragment>
      ))
    )
  }

  return (
    <>
      {dataToShow.perguntas_principais[0].perguntas_cruzadas.map((pergunta) => (
        <tbody key={pergunta.id}>
          {/* Linha com o título da pergunta de grade */}
          <tr>
            <th colSpan={dataToShow.perguntas_principais[0].alternativas.length + 4} style={{ top: headerHeight }}>
              <span className="pergunta-cruzada-wrapper">{pergunta.enunciado}</span>
            </th>
          </tr>

          {/* Agrupa as alternativas por enunciado (colunas da grade) */}
          {groupAlternativesByGridColumn(pergunta)}
        </tbody>
      ))}
    </>
  );
} 